<template>
    <div>
        <h1 class="mb-4 font-active">lifetime warranty</h1>
        <p>
            At Friendly Diamonds India, we offer a Free Lifetime Warranty against all manufacturing defects for our made-to-order and custom-made products. Our unwavering commitment to quality means that we guarantee the integrity of every diamond and jewellery piece we sell at the time of delivery.
            <br><br>
            If you ever suspect that your item is damaged, please reach out to us for guidance on how to ship it back to our quality control team for a thorough inspection. Upon inspection, if a warranted issue is found, our team will gladly repair the damage or replace the item at no cost to you. These repairs encompass services like metal shouldering, setting loose stones and tightening prongs. 
            <br><br>
            Please be aware that our lifetime warranty does not extend to items that have been previously repaired, resized or polished by anyone other than Friendly Diamonds India. Nor does it cover replacement for lost or missing diamonds, the natural wear and tear from regular use or any discoloration of metal caused by exposure to chemicals. If an issue arises that falls outside the scope of our lifetime warranty policy, we will provide you with a price quotation for approval before commencing any repair work.
        </p>

        <h2>Shipping Terms for Repaired Items</h2>
        
        <p>All repaired items are typically shipped within 10-12 business days from the date of receiving the item. If we need to remake the product, it can take up to 2 weeks.</p>


        <h2>How to Claim Warranty on Orders?</h2>
        <h4>1. Contact the Friendly Diamonds India Customer Service Department</h4>
        <ul>
            <li>
                To initiate the warranty claim process, please feel free to get in touch with us. Send an email to <a rel="nofollow noopener" :href="'mailto:'+$country.email">{{$country.email}}</a> with your order number and include the word "Repair" in the subject line. In this email, please provide all the necessary information including images related to your request. 
            </li>
            <li>
                Once we assess your warranty claim request and initiate the process, we will arrange for a convenient collection of your order from the shipping address. Note that the shipping costs for both-way shipments of the item will be your responsibility.
            </li>
        </ul>

        <h4>2. Pack Your Order</h4>
        <p>Ensure that the actual product and any <NuxtLink :to="localePath('/loose-diamonds')">loose diamonds</NuxtLink> or metal pieces are securely packed in the original packaging box.</p>
        <ul>
            <li>For security reasons, do not write ‘jewellery’, ‘diamonds’ or other related words anywhere on the package.</li>
            <li>For safety purposes, please double-box your package.</li>
            <li>To further safeguard the items, Friendly Diamonds India recommends purchasing insurance on the package up to its replacement value.</li>
        </ul>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }

    p {
        font-size: 14px;
    }
    ul li {
        font-size: 14px;
    }
}
</style>